<script>
import cssVars from 'css-vars-ponyfill'
import appConfig from '@src/app.config'
import { LightenDarkenColor } from '@utils/color-helpers'

export default {
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === 'function' ? title(this.$store) : title
      return title ? `${title} — ${appConfig.title}` : appConfig.title
    },
  },

  computed: {
    styleObject() {
      // e6046a # pink
      // 756a47 # brown
      const brandColor = '#e6046a'
      const style = {
        '--brandColor': brandColor,
        '--color-primary-darker': LightenDarkenColor(brandColor, -30),
        '--color-primary-darkest': LightenDarkenColor(brandColor, -50),
      }
      cssVars({
        onlyLegacy: true,
        variables: {
          '--brandColor': brandColor,
          '--color-primary-darker': LightenDarkenColor(brandColor, -30),
          '--color-primary-darkest': LightenDarkenColor(brandColor, -50),
        },
      })
      return style
    },
  },
}
</script>

<template>
  <div
    id="app"
    :style="styleObject"
  >
    <!--
    Even when routes use the same component, treat them
    as distinct and create the component again.
    -->
    <RouterView :key="$route.fullPath" />
  </div>
</template>

<!-- This should generally be the only global CSS in the app. -->
<style lang="scss">
// Allow element/type selectors, because this is global CSS.
// stylelint-disable selector-max-type, selector-class-pattern

// Normalize default styles across browsers,
// https://necolas.github.io/normalize.css/
@import '~normalize.css/normalize.css';
@import '~bootstrap/dist/css/bootstrap.css';
@import '~bootstrap-vue/dist/bootstrap-vue.css';
// Style loading bar between pages.
// https://github.com/rstacruz/nprogress
@import '~nprogress/nprogress.css';
@import '~swiper/css/swiper.css';
@import '~vue-select/src/scss/vue-select.scss';
// Design variables and utilities from src/design.
@import '@design';

*,
*::before,
*::after {
  box-sizing: border-box;
}

body {
  background: $color-body-bg;
}

#app {
  @extend %typography-small;
}

// ===
// Base element styles
// ===

a,
a:visited {
  color: var(--brandColor);
  &:hover {
    // color: var(--color-primary-darker);
    color: var(--brandColor);
  }
}

.btn-secondary:hover {
  color: #fff !important;
}

h1 {
  @extend %typography-xxlarge;
}

h2 {
  @extend %typography-xlarge;
}

h3 {
  @extend %typography-large;
}

h4 {
  @extend %typography-medium;
}

h5,
h6 {
  @extend %typography-small;
}

// ===
// Bootstrap Overrides
// ===
.page-link {
  color: var(--brandColor);
  &:hover {
    color: var(--color-primary-darkest);
  }
}

.page-item.active .page-link {
  background-color: var(--brandColor);
  border-color: var(--brandColor);
  &:hover {
    background-color: var(--color-primary-darker);
    border-color: var(--color-primary-darker);
  }
}

.dropdown-item {
  &:active {
    color: #fff !important;
    background-color: var(--brandColor);
    border-color: var(--brandColor);
  }
}

// ===
// Vendor
// ===

#nprogress .bar {
  background: var(--brandColor);
}

*:focus,
input:focus,
select:focus,
button:focus {
  overflow: -moz-hidden-unscrollable;
  // outline: 3px solid #3dbbdb !important;
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  // IE10+ CSS here

  /* This is just some basic styling to have it working, more needs to be done */
  .vc-container {
    width: 258px;
    .vc-header {
      width: 256px;
      padding: 10px 10px 0 10px;
    }
    .vc-arrows-container {
      padding: 8px 10px;
    }
    .vc-title {
      padding: 0 8px;
    }
    .vc-grid-container {
      display: -ms-grid;
      width: 100%;
      &.vc-weeks {
        padding: 5px 6px 7px 6px;
      }
      .vc-day-content {
        width: 2.1rem;
        height: 2.1rem;
        min-height: 2.1rem;
        margin: 0.1rem auto;
        &:focus {
          background: rgba(204, 214, 224, 0.4);
        }
        &:hover {
          background: rgba(204, 214, 224, 0.3);
        }
      }
    }
    .vc-highlight {
      width: 2.1rem;
      height: 2.1rem;
    }
  }
}
</style>
